import type { ThemeDefinition } from "../types"

import clearVerdict from "./clear-verdict"
import carbonLedger from "./carbon-ledger"
import gavelSteel from "./gavel-steel"
import midnightSyntax from "./midnight-syntax"

/** Active themes exposed in the theme picker. */
export const allThemes: ThemeDefinition[] = [
  clearVerdict,
  carbonLedger,
]

/**
 * Full catalog including hidden themes.
 * Kept for white-label / tenant overrides - not shown in the default picker.
 */
export const hiddenThemes: ThemeDefinition[] = [
  gavelSteel,
  midnightSyntax,
]

/** Maps deprecated or hidden theme IDs to active replacements */
export const THEME_MIGRATION_MAP: Record<string, string> = {
  forensic: "clear-verdict",
  "clean-light": "clear-verdict",
  executive: "clear-verdict",
  arctic: "clear-verdict",
  "rose-gold": "clear-verdict",
  ivory: "clear-verdict",
  papyrus: "clear-verdict",
  "high-contrast": "carbon-ledger",
  midnight: "carbon-ledger",
  cyberpunk: "carbon-ledger",
  "steel-dark": "carbon-ledger",
  // Hidden themes migrate to their closest active sibling
  "gavel-steel": "clear-verdict",
  "midnight-syntax": "carbon-ledger",
}
